<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('invoice.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        { text: $t('invoice.pageTitle'), href: '/invoices' },
        { text: $t('create'), active: true }
      ]" />
    </div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="row">
            <div class="col-md-6">
              <div>
                <label class="ts-uppercase ts-text-lg ts-text-blue-500 ts-font-semibold ts-mb-0">{{
                  $t('invoice.studentInfo') }}</label>
                <div class="ts-bg-pink-500 ts-h-1 ts-w-16 ts-rounded-full ts-relative">
                  <div class="ts-bg-blue-500 ts-rounded-full ts-w-2 ts-h-2 ts-absolute ts-top-0 move"
                    style="margin-top: -2px;"></div>
                </div>
                <div class="ts-p-4">
                  <StudentProfile v-model="model" :validate="errors" />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div>
                <label class="ts-uppercase ts-text-lg ts-text-blue-500 ts-font-semibold ts-mb-0">{{
                  $t('invoice.academicInfo') }}</label>
                <div class="ts-bg-pink-500 ts-h-1 ts-w-16 ts-rounded-full ts-relative">
                  <div class="ts-bg-blue-500 ts-rounded-full ts-w-2 ts-h-2 ts-absolute ts-top-0 academic-animation"
                    style="margin-top: -2px;"></div>
                </div>
                <div class="ts-p-4">
                  <Academic v-model="model" :validate="errors" />
                </div>
              </div>
            </div>
          </div>
          <div class="row"
           v-if="hasBusFee"
          >
            <div class="col-md-12">
              <div class="ts-p-2 ts-border ts-border-dashed ts-rounded-md">
                <vehicle-operation :lists="vehicle_operation_lists" :loading="loading" @reload="getVehicleOperationList"
                  style="height: max-content !important;" @vehicle="id => (model.vehicle_id = id)" />
                <div v-if="errors.has(`vehicle_id`)" class="ts-text-red-500">
                  {{ errors.first(`vehicle_id`) }}
                </div>
              </div>
            </div>
          </div>
        </ts-card-wrapper>
      </ts-card>
      <br />
      <ts-card>
        <ts-card-wrapper>
          <label class="ts-uppercase ts-text-lg ts-text-blue-500 ts-font-semibold ts-mb-0">{{ $t('invoice.itemList')
          }}</label>
          <div class="ts-bg-pink-500 ts-h-1 ts-w-16 ts-rounded-full ts-relative ts-mb-3">
            <div class="ts-bg-blue-500 ts-rounded-full ts-w-2 ts-h-2 ts-absolute ts-top-0 move"
              style="margin-top: -2px;">
            </div>
          </div>
          <ItemDetail v-model="model" :validate="errors" :bank="bankProfiles" :currency="currency"
            :exchangeRate="exchangeRate" :paymentMethod="paymentMethod" />
          <br>
          <div class="row">
            <div class="col-md-12 text-right">
              <ts-button @click.prevent="$router.push({ name: 'invoice-create' })">{{ $t('back') }}</ts-button>
              <ts-button color="primary" outline class="ml-2" @click.prevent="savePrint">{{
                $t('savePrint') }}</ts-button>
              <ts-button @click.prevent="save" color="primary" class="ml-2">{{ $t('save')
              }}</ts-button>
            </div>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </ts-loading-banner>
    <pdf-preview v-model="pdf_view" :invoice-id="invoiceId" @cancel="value => (pdf_view = value)" />
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import Academic from './component/academic-for-no-enroll.vue'
import StudentProfile from './component/create-student-for-no-enroll.vue'
import ItemDetail from './component/manual_create_details-for-no-enrollment.vue'
import PdfPreview from './component/pdf_preview'
import VehicleOperation from './component/vehicle_operation_list'

export default {
  name: 'createForStudentNoEnrollment',
  components: {
    StudentProfile,
    Academic,
    ItemDetail,
    PdfPreview,
    VehicleOperation
  },
  data() {
    return {
      loading: false,
      invoiceId: 0,
      pdf_view: false,
      errors: new Errors(),
      model: {
        pre_inv_id: 0,
        inv_date: moment().format('DD-MM-YYYY'),
        student_id: null,
        ac_year_id: null,
        acp_id: null,
        acps_id: null,
        ac_term_id: null,
        class_id: null,
        grade_id: null,
        level_id: null,
        total_amount: 0,
        amount_paid: 0,
        amount_due: 0,
        next_payment_date: null,
        remark: null,
        inv_detail_list: [],
        fee_group_id: null,
        vehicle_id: null,
        promtion_expired_date: null, // just variable show a promotion date not use to store in DB
        ac_term_stop_date: null, // just make validate not allow over stop date
        ac_term_start_date: null, // for validate less than start date,
        payment_method_id: 1,
        bank_id: null,
        account_id: null,
        // ----------------
        first_name_kh: '',
        last_name_kh: '',
        first_name_en: '',
        last_name_en: '',
        gender: '',
        study_time: null,
        discount_type: '%',
        discount_value: 0,
        discounted_amount: 0,
        received_payment: {}
      },

      bankProfiles: [],
      currency: [],
      exchangeRate: [],
      paymentMethod: [],
      vehicle_operation_lists: []
    }
  },
  computed: {
    hasBusFee() {
      const bus = this.model.inv_detail_list.find(d => d.fee_type_id === 3)
      if (bus) {
        return bus.fee_type_id
      }
      return undefined
    }
  },
  mounted() {
    this.fetchResource()
  },
  methods: {
    ...mapActions('invoiceForNoEnroll', ['store', 'formViewModel']),
    ...mapActions('invoice', [
      'getDefaultCreditDay',
      'getVehicleOperation'
    ]),
    async fetchResource() {
      this.loading = true
      await this.fetchFormView()
      this.loading = false
    },
    async fetchFormView() {
      return this.formViewModel({
        fnName: 'currency,exchangeRate,bank,paymentMethod'
      })
        .then(({ data }) => {
          this.paymentMethod = data.paymentMethod
          this.currency = data.currency
          this.exchangeRate = data.exchangeRate
          this.bankProfiles = data.bank.map(el => ({
            value: el.bank_id,
            label: el.bank_name,
            is_default: el.is_default,
            accounts: el.bank_accounts
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

    },
    routeBack() {
      this.$router.push({ name: 'invoice-create' })
    },
    savePrint() {
      this.errors = new Errors()
      this.loading = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.invoiceId = response.id
          this.pdf_view = true
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.errors = new Errors()
      this.loading = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'invoice-create' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model.pre_inv_id = 0
      this.model.inv_date = moment()
      this.model.student_id = null
      this.model.ac_year_id = null
      this.model.acp_id = null
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = null
      this.model.grade_id = null
      this.model.total_amount = 0
      this.model.amount_paid = 0
      this.model.amount_due = 0
      this.model.next_payment_date = null
      this.model.remark = null
      this.model.inv_detail_list = []
      this.model.fee_group_id = null
      this.model.vehicle_id = null
      this.model.promtion_expired_date = null
      this.model.received_payment = {}
      this.preDetails = {}
    },
    async getVehicleOperationList() {
      this.loading = true
      if (!this.vehicle_operation_lists.length) {
        await this.getVehicleOperation({
          include:
            'operations,operations.vehicle_zone,operations.driver,employee',
          fields: {
            operations: 'vehicle_id,zone_id,driver_staff_id',
            'operations.vehicle_zone': 'zone_id,zone_name_en',
            setup_transportation_vehicle_info:
              'vehicle_id,plate_no,max_student,vehicle_assistant_staff_id',
            'operations.driver': 'staff_id,name_en',
            employee: 'staff_id,name_en'
          },
          page: -1
        })
          .then(response => {
            this.vehicle_operation_lists = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
  watch: {
    hasBusFee: function (value) {
      if (value) {
        this.getVehicleOperationList()
      }
    }
  }
}
</script>

<style lang="css">
.move {
  animation: moveLeft infinite;
  animation-duration: 3s;
}

.academic-animation {
  animation: moveLeft infinite;
  animation-duration: 8s;
}

@keyframes moveLeft {
  0% {
    background-color: #4299e1;
    left: 0px;
    top: 0px;
  }

  100% {
    background-color: #4299e1;
    left: 3.5rem;
    top: 0px;
  }
}
</style>
